import React from 'react';
import StepNumber from '../page/StepNumber';
import { tie } from '../page/typography';
import { stageAnchor } from './LaunchRoute';

/**
 * Етапи — один під одним, як шлях, а не сіткою 2×3.
 *
 * У сітці погляд ішов зигзагом (1 → 2, униз, 3 → 4), а картки в ряду
 * розтягувалися до сусідньої: у «Матеріально-технічній базі» два пункти й
 * пів картки порожнечі. Тепер кожен етап — рядок на всю ширину: номер і
 * назва ліворуч, пункти праворуч переліком «що — як». Висота картки — це
 * висота її пунктів, а лінія від кружка до кружка тримає послідовність.
 *
 * Назва ліворуч — лише від xl: на 1024 права колонка ставала такою вузькою,
 * що пояснення до пункту йшло в три рядки по три слова. Лінія від xl іде
 * крізь ліву колонку картки (там під назвою вільно), нижче — лише в
 * проміжку між картками: пункти там на всю ширину, і лінія перекреслювала
 * б текст. Координати — центр кружка: відступ картки + рамка + половина
 * StepNumber size="lg" (44px).
 *
 * Кружок залитий, а на шляху вгорі — світлий, що заливається при наведенні:
 * плитка шляху лише веде сюди, а етап і є місце призначення.
 */
const LaunchStages = ({ stages }) => (
  <ol className="list-none space-y-5">
    {stages.map((stage, i) => {
      const last = i === stages.length - 1;
      return (
        <li key={stage.number} id={stageAnchor(i)} className="relative scroll-mt-28">
          {!last && (
            <>
              <span
                className="xl:hidden absolute left-[calc(2.625rem+0.5px)] sm:left-[calc(2.875rem+0.5px)] lg:left-[calc(3.375rem+0.5px)] top-full h-5 w-px bg-teal-200"
                aria-hidden="true"
              ></span>
              <span
                className="hidden xl:block absolute left-[calc(3.375rem+0.5px)] top-[calc(5.25rem+1px)] bottom-[calc(-2.75rem-1px)] w-px bg-teal-200"
                aria-hidden="true"
              ></span>
            </>
          )}

          <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 lg:p-8 xl:grid xl:grid-cols-[minmax(0,19rem)_minmax(0,1fr)] xl:gap-10">
            <div className="flex items-center gap-4 xl:items-start">
              <StepNumber n={i + 1} size="lg" variant="filled" />
              <div className="min-w-0">
                {/* Без uppercase: велика «З» між цифрами читалася як «1 3 6». */}
                <p className="text-sm font-semibold text-teal-700">
                  {`Етап ${i + 1} з ${stages.length}`}
                </p>
                <h2 className="mt-0.5 text-xl lg:text-2xl font-bold font-display text-slate-900 leading-tight text-balance">
                  {stage.title}
                </h2>
              </div>
            </div>

            <dl className="mt-5 border-t border-slate-100 divide-y divide-slate-100 xl:mt-0 xl:border-t-0">
              {stage.items.map((item) => (
                <div
                  key={item.label}
                  className="py-4 last:pb-0 xl:first:pt-0 md:grid md:grid-cols-[minmax(0,15rem)_minmax(0,1fr)] md:gap-8"
                >
                  <dt className="font-semibold text-slate-900 leading-snug">{tie(item.label)}</dt>
                  <dd className="mt-1 md:mt-0 text-slate-600 leading-relaxed">{tie(item.text)}</dd>
                </div>
              ))}
            </dl>
          </div>
        </li>
      );
    })}
  </ol>
);

export default LaunchStages;
